import { formsConstantsValidation } from "common/constants/formsConstantsValidation";
import moment from "moment";

export const formatInMoscowDate = (
  date?: string,
  {
    withTime,
    withSeconds = false,
    format = "DD/MM/YYYY",
    utc = true,
  }: { withTime?: boolean; withSeconds?: boolean; format?: string; utc?: boolean } = {}
): string => {
  const dateStringWithoutTimezon = date?.split("Z")[0];

  if (!dateStringWithoutTimezon || dateStringWithoutTimezon === "0001-01-01T00:00:00") {
    return "";
  }

  const dateMoscowInMiliseconds = +new Date(dateStringWithoutTimezon) + (utc ? 10800000 : 0);

  if (withTime) {
    return moment(dateMoscowInMiliseconds).format(withSeconds ? "DD/MM/YYYY HH:mm:ss" : "DD/MM/YYYY HH:mm");
  }

  return moment(dateMoscowInMiliseconds).format(format);
};

export const getFormatedDate = (date?: string, format: string = formsConstantsValidation.dateFormat) => {
  if (!date) {
    return "";
  }

  return moment(date).format(format);
};
